
































































import 'reflect-metadata'
import { Component, Vue, Prop } from 'vue-property-decorator'
import { DeedCustomerApi } from "@/api"

@Component
export default class DeedDialogRemove extends Vue { 
    @Prop(Function) public getDeedProspect: any
    @Prop(Function) public notifcation: any
    @Prop(Function) public UpdateDeedNameByUnitId: any

    loading = false
    dialog = false
    customerName = ""
    bookingid = ""
    unitId = ""
    newObjectRemove = [] as any[]
    selectedItemNo = 0

    openDialog (bookingid: string, unitId: string, objectRemove: any[], selectedItem: any) {
        this.dialog = true
        this.customerName = selectedItem.customerName
        this.bookingid = bookingid
        this.unitId = unitId
        this.newObjectRemove = objectRemove
        this.selectedItemNo = selectedItem.no
    }

    async okDialog () {
        this.loading = true
        this.dialog = false
        const createObjectRemvoe = this.createObjectRemvoe(this.newObjectRemove, this.selectedItemNo)
        const objectRequestApi = this.createObjectRequestApi(createObjectRemvoe, this.bookingid)
        await DeedCustomerApi.UpsertDeedProspect(objectRequestApi)
        const deedNameLists = await this.getDeedProspect(this.bookingid)
        await this.UpdateDeedNameByUnitId(this.unitId, deedNameLists)
        this.notifcation(`${this.customerName} ถูกลบสำเร็จ`, "success")
        this.loading = false
    }

    createObjectRemvoe (objectRemove: any[], no: number) {
        if (objectRemove.length === 0) return objectRemove

        if (objectRemove[0].no == no) {
            objectRemove[0].prospectId = 0
            objectRemove[0].customerName = ""
            return objectRemove
        }
        if (objectRemove[1].no == no) {
            objectRemove[1].prospectId = 0
            objectRemove[1].customerName = ""
            return objectRemove
        }
        if (objectRemove[2].no == no) {
            objectRemove[2].prospectId = 0
            objectRemove[2].customerName = ""
            return objectRemove
        }
        if (objectRemove[3].no == no) {
            objectRemove[3].prospectId = 0
            objectRemove[3].customerName = ""
            return objectRemove
        }
        return objectRemove
    }
    
    createObjectRequestApi (deedProspectLists: any[], bookingid: string) {
        const data = {
            bookingid: `${bookingid}`,
            deedProspectId1: deedProspectLists[0].prospectId == 0 ? "" : `${deedProspectLists[0].prospectId}`,
            deedProspectId2: deedProspectLists[1].prospectId == 0 ? "" : `${deedProspectLists[1].prospectId}`,
            deedProspectId3: deedProspectLists[2].prospectId == 0 ? "" : `${deedProspectLists[2].prospectId}`,
            deedProspectId4: deedProspectLists[3].prospectId == 0 ? "" : `${deedProspectLists[3].prospectId}`,
        }
        return data
    }
}
